"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animateTabIndicatorBaseSpec = void 0;
const animateTabIndicatorBaseSpec = {
  property: 'x',
  easing: 'global',
  duration: 'moderate1'
};
exports.animateTabIndicatorBaseSpec = animateTabIndicatorBaseSpec;